import { Box, IconButton, Flex, Icon, Text } from '@chakra-ui/react';
import { ChevronLeft } from 'react-iconly';
import { useSteps } from 'react-step-builder';
import { useHistory } from 'react-router-dom';
import { XIcon } from '@heroicons/react/outline';
import { OutreachForm } from '../outreach-form';
import { useCreateOutreachMutation } from '@/store/query/outreach';
import { outreachFormDataToPayload } from '../utils/outreach-formdata-to-payload';
import { useMixpanel } from '@/hooks/use-mixpanel';
import { useShowToast } from '@/hooks/useShowToast';

const Header = ({ onClose = () => {} }) => {
  const { jump } = useSteps();

  return (
    <Flex
      height="80px"
      borderBottom="1px"
      borderBottomColor="#E5E5E5"
      alignItems="center"
      px="24px"
    >
      <Flex flex="1" alignItems="center">
        <Box
          cursor="pointer"
          pos="relative"
          top="2px"
          onClick={() => {
            jump(1);
          }}
        >
          <Icon as={ChevronLeft} set="light" width="20px" height="20px" />
        </Box>
        <Text
          color="#0043CE"
          textDecor="underline"
          fontSize="14px"
          ml="4px"
          cursor="pointer"
          fontWeight="medium"
          onClick={() => {
            jump(1);
          }}
        >
          Create Flow
        </Text>
        <Box ml="8px">/</Box>
        <Text ml="4px" fontWeight="medium">
          New Flow
        </Text>
      </Flex>
      <Box></Box>
      <Box>
        <IconButton
          variant="icon"
          ml="16px"
          onClick={onClose}
          icon={<Icon as={XIcon} width="16px" height="16px" />}
        />
      </Box>
    </Flex>
  );
};

export const CreateFromScratch = ({
  onClose = () => {},
  quickCreate = false,
}) => {
  const { track } = useMixpanel();
  const [createOutreach, { isLoading }] = useCreateOutreachMutation();
  const toast = useShowToast();
  const history = useHistory();

  const onSubmit = async (outreachFormData) => {
    const outreach = outreachFormDataToPayload(outreachFormData);
    try {
      const result = await createOutreach(outreach);
      if (result?.data?.id) {
        history.push(`/flows/${result?.data?.id}/steps`);
        toast({
          title: 'Flow created',
          position: 'bottom-left',
          status: 'success',
          isClosable: true,
        });
        track({
          event: 'outreach-created',
          prop: { source: 'new' },
        });
        if (quickCreate) {
          onClose();
          return;
        }
        return;
      }
      toast({
        title: 'Flow creation failed',
        description: result?.error?.title,
        position: 'bottom-left',
        status: 'error',
        isClosable: true,
      });
    } catch {}
  };

  return (
    <Flex flexDir="column" height="inherit">
      <Header onClose={onClose} />
      <Box flex="1" height="calc(100% - 80px)">
        <OutreachForm onSubmit={onSubmit} isLoading={isLoading} />
      </Box>
    </Flex>
  );
};
